
<ng-container *ngIf="permissionPath else template">

    <div *permissionIf="permissionPath">
        <ng-container *ngIf="!permissionPath else template">
        </ng-container>
    </div>

</ng-container>

<ng-template #template>
    <div class="clickEdit"
         [class.disabled]="isReadOnlyMode()">
        <div class="popoverOpener"
             (click)="openIfNotReadOnlyMode()">
            <fa-icon *ngIf="icon && icon !== '' && !iconDefinition" [icon]="icon | iconNameToDefinition" ></fa-icon>
        <fa-icon *ngIf="iconDefinition" [icon]="iconDefinition" ></fa-icon>
            <span class="formLabel titleData-text-transform"
                  *ngIf="canShowFormLabel()"
                  [class.formLabel]="formLabel"
                  [class.isActive]="formIsActive"
                  [class.required]="required"
                  (click)="focusIfNotReadOnlyMode()">
            {{ label }}
        </span>

            <ng-container *ngIf="!editFormIsOpen">
                <span *ngIf="hasEditableValueAndFormLabel()">&nbsp;:&nbsp;</span>
                <span *ngIf="!forceEditablePlaceHolder && hasVisibleEditableValue()"
                      class="titleData-text-transform">
                {{ inEditionForm.value }} <span *ngIf="unit !== ''"> {{ unit }}</span>
            </span>
                <ng-content *ngIf="(forceEditablePlaceHolder || hasHiddenEditableValue())"
                            select=".editablePlaceholder"></ng-content>
                <!-- this following input helps to simulate the focus event to catch
                for opening the tinymce form with tab navigation as example-->
                <input class="hiddenInput" type="text" (focus)="toggleEditForm(false);">
            </ng-container>
        </div>
        <div [class.titleEditor]="mode === modes.head">
            <div *ngIf="editFormIsOpen"
                 (clickOutside)="validateOnClickOutside()"
                 [class.inlinePopOver]="mode === modes.inline">
                <div class="popoverArrow-topLeft" *ngIf="mode === modes.detail"></div>
                <form class="popoverContainer">
                    <i class="fa {{ icon }}" *ngIf="this.icon !== '' && mode !== modes.inline"></i>
                    <input class="textInput"
                           #textInput
                           (keydown)="keyAction($event);"
                           [focusIf]="true"
                           (keyup)="checkValidValue(pattern)"
                           (focus)="formIsActive = true"
                           (blur)="formIsActive = false; forceFocus = false"
                           [type]="inputType"
                           [(ngModel)]="inEditionForm.value"
                           [maxlength]="charLimit"
                           placeholder="{{ label }}"
                           name="value">
                    <div class="buttonGroup buttonGroup-bottomPosition"
                         *ngIf="(mode === modes.detail && isButtonPosition(buttonPositions.default)) || isButtonPosition(buttonPositions.bottom)">
                        <button class="plainButton closeButton"
                                type="button"
                                (click)="cancel();">
                            <fa-icon [icon]="iconTimesCircle"></fa-icon>
                            <ng-container *ngIf="mode === modes.head">{{ t_cancel }}</ng-container>
                        </button>
                        <button class="plainButton tickButton"
                                type="button"
                                (click)="validate();">
                            <fa-icon [icon]="iconCheckCircle"></fa-icon>
                            <ng-container *ngIf="mode === modes.head">{{ t_valid }}</ng-container>
                        </button>
                    </div>
                    <div class="buttonGroup buttonGroup-topPosition"
                         *ngIf="(mode === modes.head && isButtonPosition(buttonPositions.default)) || isButtonPosition(buttonPositions.top)">
                        <button class="plainButton closeButton"
                                type="button"
                                (click)="cancel();">
                            <fa-icon [icon]="iconTimesCircle"></fa-icon>
                            {{ t_cancel }}
                        </button>
                        <button class="plainButton tickButton"
                                type="button"
                                (click)="validate();">
                            <fa-icon [icon]="iconCheckCircle"></fa-icon>
                        {{ t_valid }}
                    </button>
                    <ng-content select=".additional-button"></ng-content>
                </div>
            </form>
            <ng-content select=".after-form-field"></ng-content>
        </div>
        <p class="errorMessage" *ngIf="inEditionForm.value.length > charLimit">
            *{{ t_the }} {{ label }} {{ t_contain }} {{inEditionForm.value.length - charLimit}}
            <span *ngIf="inEditionForm.value.length > (charLimit + 1)">{{ t_tooMuchChars }}</span>
            <span *ngIf="inEditionForm.value.length <= (charLimit + 1)">{{ t_tooMuchChar }}</span>
        </p>
        <p class="errorMessage" *ngIf="( pattern !== '' && uiPattern.error.flag === true )">
            *{{ uiPattern.error.message }}
        </p>
    </div>
</div>
</ng-template>
